export default __webpack_public_path__ + "assets/images/539-small.webp";